import React from 'react';
import PropTypes from 'prop-types';

import { TouchableOpacity , Alert, View} from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import Text from '../../../../../../../src/components/common/text';
import NavigationArrow from '../../../../../../../src/components/common/navigation-arrow';
import { Currency } from '../../../../../../../src/components/common/number';
import { createContainer } from '@dbk-legacy/muster/react';

import styles from '../../../../../../../src/screens/portfolio/dashboard/net-income/net-income.styles';

function renderArrow(netIncome, arrowSize, propsValue) {
  if (netIncome == undefined || propsValue.app.user.selectedPortfolioData.relId) {
    return null;
  }

  return (
    <NavigationArrow size={arrowSize} />
  );

}

function NetIncome({ netIncome, netIncomeUnit, onPress, ...props}) {
  const propsValue = props;
  let arrowSize, netIncomeHeaderSize;
  if(propsValue.app.global.deviceInfo.isTablet){
      netIncomeHeaderSize = 'large32';
      arrowSize = 'large';
    } else {
      netIncomeHeaderSize = 'large32';
      arrowSize = 'normal';
    }

  return (
    <TouchableOpacity
      onPress={() => {
        console.log("netIncome @ component", netIncome);
        if (netIncome != null && netIncome != 0) {
          onPress();
        } else {
          alert(propsValue.i18n.messages['app.netincome.noIncExp']);
        }
      }}
      testID="net-income-container"
      style={styles.justify}
      className="net-income-container"
    >
      <View style={[styles.netIncomeLabel, styles.align]} id="net-income-label">
        <Text >{propsValue.i18n.messages['app.netincome.netIncText']}</Text>
      </View>
      <View className="net-income-value" id="text_currency_netIncome_test">
        <Currency
          signBeforeNumber={false}
          currencyStyle={styles.currencyStyle}
          decimalStyle={styles.decimalStyle}
          renderProps={{
            size: netIncomeHeaderSize,
            style: styles.value,
            testID: 'net-income',
          }}
          currency={netIncomeUnit}
          value={netIncome}
        />
        <View className="net-income-arrow">
          {renderArrow(netIncome, arrowSize, propsValue)}
        </View>
      </View>
    </TouchableOpacity>
  );
}

NetIncome.propTypes = {
  netIncome: PropTypes.number,
  netIncomeUnit: PropTypes.string,
  onPress: PropTypes.func.isRequired,
};

export default createContainer({
  $queries: {
    app:{
      global:{
        deviceInfo: {
          isTablet: true,
        }
      },
      user: {
        selectedPortfolioData: true,
      },
    },
    i18n: {
      messages: true,
    },
  },
})(pure(NetIncome));
